import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgChat = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 92,
	height: 91,
	viewBox: "0 0 92 91",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_43_244)",
		children: [
			/* @__PURE__ */ _jsx("path", {
				d: "M88.5083 58.6157C88.5083 49.5306 84.1527 41.4744 77.4352 36.4328C75.5232 17.6145 59.7264 2.93225 40.5197 2.93225C20.0298 2.93225 3.41498 19.6517 3.41498 40.2706C3.41498 46.6446 5.00489 52.643 7.80129 57.8955L3.72683 78.7767L24.503 73.9615C29.3494 76.3023 34.7837 77.609 40.5197 77.609C40.7037 77.609 40.8826 77.609 41.0667 77.6038C46.0767 82.9335 53.1674 86.2619 61.0351 86.2619C65.2834 86.2619 69.3016 85.2896 72.8955 83.5611L88.2783 87.1262L85.2621 71.6671C87.3325 67.7779 88.5083 63.3383 88.5083 58.6157Z",
				stroke: "white",
				strokeWidth: 4.9411,
				strokeMiterlimit: 10
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M61.0351 30.9695C76.2083 30.9695 88.5083 43.347 88.5083 58.6157C88.5083 63.3332 87.3325 67.778 85.262 71.6672L88.2783 87.1262L72.8955 83.5611C69.3067 85.2948 65.2834 86.2619 61.0351 86.2619C45.862 86.2619 33.5619 73.8844 33.5619 58.6157C33.5619 43.347 45.862 30.9695 61.0351 30.9695Z",
				fill: "#004F96"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M40.5197 2.93225C20.0298 2.93225 3.41498 19.6517 3.41498 40.2706C3.41498 46.6446 5.00489 52.643 7.80129 57.8955L3.72683 78.7767L24.503 73.9615C29.3494 76.3023 34.7837 77.609 40.5197 77.609C61.0147 77.609 77.6244 60.8895 77.6244 40.2706C77.6244 19.6517 61.0147 2.93225 40.5197 2.93225Z",
				fill: "url(#paint0_linear_43_244)"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M27.6675 35.085H55.2429",
				stroke: "#FCFCFC",
				strokeWidth: 6.17637,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M27.6675 45.0601H55.2429",
				stroke: "#FCFCFC",
				strokeWidth: 6.17637,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			})
		]
	}), /* @__PURE__ */ _jsxs("defs", { children: [/* @__PURE__ */ _jsxs("linearGradient", {
		id: "paint0_linear_43_244",
		x1: 3.41498,
		y1: 40.8571,
		x2: 77.6244,
		y2: 40.8571,
		gradientUnits: "userSpaceOnUse",
		children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#3790F4" }), /* @__PURE__ */ _jsx("stop", {
			offset: 1,
			stopColor: "#0567D5"
		})]
	}), /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_43_244",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 92,
			height: 91,
			fill: "white"
		})
	})] })]
});
export default SvgChat;
